import React from 'react'
import VerticalGroup from '../../../atoms/verticalgroup/VerticalGroup'
import TableWithSections from '../tables/TableWithSections'
import pluckResultsByType from '../utils/pluckResultsByType'
import { excoDecisions } from '../constants'
import startCase from 'lodash.startcase'
import { percentage } from '../utils/formatters'

interface Props {
  configuration: ModelAPI.ConfigurationResponse
  data: ModelAPI.TeamResultsResponse['excoDecisions']
}

const onlyHas2Options = ['employee-costs-10%', 'bonus-season', 'know-your-customer']
const totalSections = [
  'communityTrustImpactReputation',
  'employeeEngagementImpact',
  'customerSatisfactionCardBusinessOnly',
  'customerSatisfactionAllProducts',
  'customerComplaints',
  'changeInUnresolvedRiskIncidents',
  'changeInRiskWeightedAssetsCards',
  'changeInRiskWeightedAssetsBusinessLoans',
  'changeInCreditCardInterestIncomePercentageChange',
  'changeInCreditCardReveueImpact',
  'changeInCreditCardCustomerAnnualSpendPerCustomer',
  'changeInTotalCreditCardCustomerAnnualSpendWholeBank',
  'additionalAttritionInBusinessCustomers',
  'remediationAndFines',
  'investmentCosts',
  'changeToCostToAssetRatioAllBusinesses'
]

const excoFields = [
  'reductionInCostAssetRatios',
  'reputationImpact',
  'increaseInNewRiskIncidents',
  'reductionInEmployeeEngagement',
  'interestIncomeImpact',
  'npsImpactOfCardsBusiness',
  'customerComplaintsImpact',
  'costOfDevelopment',
  'npsImpact',
  'riskWeightReductionCards',
  'changeInCreditCardCustomerAnnualSpendPerCustomer',
  'remediationAndFines',
  'additionalAttritionInBusinessCustomers',
  'changeInCreditCardReveueImpact',
  'changeInRiskWeightedAssetsBusinessLoans',
  'changeInTotalCreditCardCustomerAnnualSpendWholeBank',
  'unethicalLoans',
  'investment',
  'investmentValue',
  'terminalValueImpact'
]

const impactFormatter = (val: number, field: string) => {
  if ([
    'interestIncomeImpact',
    'reductionInCostAssetRatios',
    'reputationImpact',
    'reductionInEmployeeEngagement',
    'riskWeightReductionCards',
    'additionalAttritionInBusinessCustomers',
    'changeInRiskWeightedAssetsBusinessLoans',
    'changeInTotalCreditCardCustomerAnnualSpendWholeBank'
  ].includes(field)) {
    return percentage(val)
  }
  return null
}

const ModelTeamResultsExcoDecisions: React.FC<Props> = ({ data }) => {
  const excoData = pluckResultsByType(data, 'excoDecisions')
  const totalData = pluckResultsByType(data, 'total')
  return (<>
    <VerticalGroup className='mt-2' spaceBetweenElements={2} wide>
      {excoDecisions.map(e => {
        const dataForDecision = pluckResultsByType(excoData, e)
        const sections = [{
          name: 'Option A - Impacts',
          fields: excoFields,
          values: pluckResultsByType(dataForDecision, 'optionA'),
          formatter: impactFormatter
        }, {
          name: 'Option B - Impacts',
          fields: excoFields,
          values: pluckResultsByType(dataForDecision, 'optionB'),
          formatter: impactFormatter
        }]
        if (!onlyHas2Options.includes(e)) {
          sections.push({
            name: 'Option C - Impacts',
            fields: excoFields,
            values: pluckResultsByType(dataForDecision, 'optionC'),
            formatter: impactFormatter
          })
        }
        return <TableWithSections
          key={e}
          header={e}
          data={sections}
        />
      })}
      <TableWithSections
        header='Total Executive Decision Impacts - All Decisions'
        data={totalSections.map((ts) => ({
          key: ts,
          name: startCase(ts),
          fields: [
            ...excoDecisions,
            'total'
          ],
          totalFields: ['total'],
          values: pluckResultsByType(totalData, ts),
          formatter: (value: number) => {
            if ([
              'communityTrustImpactReputation',
              'employeeEngagementImpact',
              'changeInRiskWeightedAssetsCards',
              'changeInRiskWeightedAssetsBusinessLoans',
              'changeInCreditCardInterestIncomePercentageChange',
              'changeInTotalCreditCardCustomerAnnualSpendWholeBank',
              'additionalAttritionInBusinessCustomers',
              'changeToCostToAssetRatioAllBusinesses'
            ].includes(ts)) {
              return percentage(value)
            }
            return null
          }

        }))}
      />
    </VerticalGroup>
  </>)
}

export default ModelTeamResultsExcoDecisions